var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<strong>'+
((__t=( data.name + ':' ))==null?'':__t)+
'</strong> '+
((__t=( data.ref ))==null?'':__t)+
'\n';
return __p;
};
